export const SET_LAYOUT = "setLayout"
export const TOGGLE_SIDE_BAR = "toggleSideBar"
export const TOGGLE_SEARCH = "toggleSearch"
export const TOGGLE_LOCALE = "toggleLocale"
export const TOGGLE_DARK_MODE = "toggleDarkMode"
export const TOGGLE_MENU_STYLE = "toggleMenuStyle"
export const TOGGLE_LAYOUT_STYLE = "toggleLayoutStyle"
export const SET_AUTH_DATA = "setAuthData"
export const LOG_OUT_USER = "LOG_OUT_USER"
export const IS_LOADING = "IS_LOADING"
export const SET_AUTH_DATA_IN_STATE = "SET_AUTH_DATA_IN_STATE"
export const FORGET_PASSWORD = "FORGET_PASSWORD"
export const CONFIRM_FORGET_PASSWORD = "CONFIRM_FORGET_PASSWORD"
export const SET_AUTHENTICATED_PAGE_ON_FORCE_RELOAD = "SET_AUTHENTICATED_PAGE_ON_FORCE_RELOAD"



